"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrainLifeAbilityHandler = exports.DrainLifeActorAbilityFactory = exports.DrainLifeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Damage_1 = require("../../core/Damage");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class DrainLifeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.DrainLife;
        this.__typeName = "DrainLife";
    }
}
exports.DrainLifeAbilityArgs = DrainLifeAbilityArgs;
let DrainLifeActorAbilityFactory = class DrainLifeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("DrainLife", "OneEnemies", 0);
    }
};
DrainLifeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("DrainLife")
], DrainLifeActorAbilityFactory);
exports.DrainLifeActorAbilityFactory = DrainLifeActorAbilityFactory;
let DrainLifeAbilityHandler = class DrainLifeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Focus("Death", 40)
            ],
            projectileType: "PurpleEvilComet",
            projectilePath: "line",
            onHit(sequence, _attack, damages) {
                const sum = Damage_1.Damage.Sum(damages);
                container.applyHealing({
                    sequence,
                    healerId: ability.invokerId,
                    targetId: ability.invokerId,
                    amount: Math.round(sum * .5),
                    onApplied: sequence => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy), "PulsingBlood"))
                });
                const ruinated = container.readLocal(ability.invokerId, "Ruination_AppliedToId", 0);
                if (ruinated > 0) {
                    container.applyAttackDamage({
                        attackType: "magic_tick",
                        sequence,
                        attackerId: ability.invokerId,
                        targetId: ruinated,
                        isCrit: false,
                        toApply: AbilityDamage_1.AbilityDamage.Focus("Death", 100)
                    });
                }
            }
        });
    }
};
DrainLifeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.DrainLife)
], DrainLifeAbilityHandler);
exports.DrainLifeAbilityHandler = DrainLifeAbilityHandler;
